export function isNodeWithContent(node) {
  return node !== undefined && node !== null && node !== false;
}